'use client';

import { useEffect } from 'react';

export default function KoFiWidget() {
  useEffect(() => {
    const setIframeTitles = () => {
      const iframes = document.querySelectorAll('iframe');
      iframes.forEach((iframe) => {
        const src = iframe.getAttribute('src') || '';
        if (src.includes('ko-fi.com') || src.includes('storage.ko-fi.com')) {
          if (!iframe.getAttribute('title')) {
            iframe.setAttribute('title', 'Ko-fi support widget');
          }
        }
      });
    };

    const script = document.createElement('script');
    script.src = 'https://storage.ko-fi.com/cdn/scripts/overlay-widget.js';
    script.async = true;
    script.onload = () => {
      if (typeof kofiWidgetOverlay !== 'undefined') {
        kofiWidgetOverlay.draw('munichindians', {
          type: 'floating-chat',
          'floating-chat.donateButton.text': 'Support Us',
          'floating-chat.donateButton.background-color': '#794bc4',
          'floating-chat.donateButton.text-color': '#fff',
        });
        setIframeTitles();
      }
    };
    document.body.appendChild(script);

    const observer = new MutationObserver(() => setIframeTitles());
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
    };
  }, []);

  return null;
}
